<template>
<v-dialog
  v-model="visible"
  max-width="500px"
>
  <template v-slot:activator="{ on, attrs }">
    <v-btn
      color="primary"
      dark
      v-bind="attrs"
      v-on="on"
    >
      Add to a Category
    </v-btn>
  </template>
  <v-card>
    <v-card-title>Add the selected songs to a category.</v-card-title>

    <v-card-text>
      <v-container>
        <v-row justify="center">
          <v-col>
            <CategoriesAutocomplete
              v-model="selectedCategories"
              :categories.sync="propCategories"
            ></CategoriesAutocomplete>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
      <v-btn color="blue darken-1" text @click="save">Add</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import CategoriesAutocomplete from "@/components/CategoriesAutocomplete";
import apiClient from "@/utils/apiClient";

export default {
  name: "SongAddToCategoriesDialog",
  props: {
    categories: {
      type: Array,
      default: () => ([]),
    },
    selectedSongs: {
      type: Array,
      required: true,
    }
  },
  components: { CategoriesAutocomplete },

  data: function () {
    return {
      propCategories: Array.from(this.categories),
      propSelectedSongs: Array.from(this.selectedSongs),

      visible: false,
      selectedCategories: [],
    }
  },

  computed: {
    form() {
      return {
        songs: this.propSelectedSongs,
        categories: this.selectedCategories,
      }
    }
  },

  watch: {
    propCategories(val) {
      this.$emit('update:categories', val)
    },
    visible(val) {
      if (!val)
        this.selectedCategories = []
      else
        this.propSelectedSongs = Array.from(this.selectedSongs)
    },
  },

  methods: {
    close() {
      this.visible = false
    },

    save() {
      apiClient
        .createSongCategory(this.form)
        .then(() => {
          this.visible = false
          this.$emit('done')
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
